import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Button,
  Alert,
  AlertIcon,
  FormControl,
  FormLabel,
  Switch,
  Spinner
} from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';

interface ProjectDeleteModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (cascadeDelete: boolean) => void;
  projectTitle: string;
  tasksCount?: number;
}

export const ProjectDeleteModal: React.FC<ProjectDeleteModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  projectTitle,
  tasksCount = 0
}) => {
  const { t } = useTranslation(['v0/projects', 'v0/common']);
  const [cascadeDelete, setCascadeDelete] = useState(true);
  const [isDeleting, setIsDeleting] = useState(false);

  const handleConfirm = async () => {
    if (isDeleting) return;

    setIsDeleting(true);
    try {
      await onConfirm(cascadeDelete);
      onClose();
    } catch (error) {
      console.error('删除项目失败:', error);
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
    >
      <ModalOverlay />
      <ModalContent borderRadius="xl" mx={4}>
        <ModalHeader>{t('v0/projects:deleteModal.title')}</ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={6}>
          <Alert status="warning" borderRadius="md" mb={4}>
            <AlertIcon />
            <p>
              {t('v0/projects:deleteModal.confirmation', { title: projectTitle })}
            </p>
          </Alert>

          {tasksCount > 0 && (
            <FormControl display="flex" alignItems="center" mb={4}>
              <FormLabel htmlFor="cascade-delete" mb="0" fontSize="sm">
                {t('v0/projects:dialogs.deleteProject.warningWithCount', { count: tasksCount })}
              </FormLabel>
              <Switch
                id="cascade-delete"
                isChecked={cascadeDelete}
                onChange={(e) => setCascadeDelete(e.target.checked)}
                colorScheme="red"
              />
            </FormControl>
          )}

          <div className="flex justify-end gap-3">
            <Button onClick={onClose} isDisabled={isDeleting}>
              {t('v0/common:actions.cancel')}
            </Button>
            <Button
              colorScheme="red"
              onClick={handleConfirm}
              isLoading={isDeleting}
              loadingText={t('v0/common:actions.deleting')}
            >
              {t('v0/projects:deleteModal.confirm')}
            </Button>
          </div>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};